<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetExtended" });
import { InputStreet, InputBuilding, InputPostalCode, InputLocality, SelectCountry, SelectAddressType } from "../../../index.js";
import { Button } from "../../../../../elements/index.js";
import SectionHeader from "../../../../../components/section-header/SectionHeader.svelte";
import SelectForkliftAvailability from "../../select-forklift-availability/SelectForkliftAvailability.svelte";
import SelectRampAvailability from "../../select-ramp-availability/SelectRampAvailability.svelte";
import SelectPalletExchange from "../../select-pallet-exchange/SelectPalletExchange.svelte";
import InputSpecialRequirements from "../../input-special-requirements/InputSpecialRequirements.svelte";
import InputOpeningTimes from "./components/input-opening-times/InputOpeningTimes.svelte";
import InputContacts from "./components/input-contacts/InputContacts.svelte";
import { slide } from "svelte/transition";
export let address = {};
export let action = "create";
export let showCancel = false;
export let onCancel = () => {
};
export let openingTimes;
export let organizationKey;
export let contactKeys = [];
let isWarehouseExpanded = false;
let isOpeningTimesExpanded = false;
let isContactsExpanded = false;
$: isWarehouseAddress = address.type === "inbound" || address.type === "outbound";
</script>

<div class = 's8-row-of-3'>
    <SelectAddressType bind:key = { address.type } />
    <InputStreet bind:value = { address.street } />
    <InputBuilding bind:value = { address.building } />
</div>

<div class = 's8-row-of-3'>
    <InputPostalCode bind:value = { address.postalCode }/>
    <InputLocality bind:value = { address.locality }/>
    <SelectCountry bind:key = { address.countryCode }/>
</div>

{#if isWarehouseAddress}
    <SectionHeader label = 'Warehouse Information' bind:isVisible = { isWarehouseExpanded } />

    {#if isWarehouseExpanded}
        <div transition:slide>
            <div class = 's8-row-of-3'>
                <SelectForkliftAvailability bind:key = { address.forkliftAvailabilityCode } />
                <SelectRampAvailability bind:key = { address.rampAvailabilityCode } />
                <SelectPalletExchange bind:key = { address.palletExchangeCode } />
            </div>

            <InputSpecialRequirements bind:value = { address.specialRequirements } />
        </div>
    {/if}

    <SectionHeader label = 'Opening Times' bind:isVisible = { isOpeningTimesExpanded } />

    {#if isOpeningTimesExpanded}
        <div transition:slide>
            <InputOpeningTimes bind:values = { openingTimes } />
        </div>
    {/if}
{/if}

<SectionHeader label = 'Contacts' bind:isVisible = { isContactsExpanded } />

{#if isContactsExpanded}
    <div class = 's8-contacts' transition:slide>
        <InputContacts bind:contactKeys { organizationKey } addressType = { address.type } />
    </div>
{/if}

<div class = 's8-form-buttons'>
    <Button
        type = 'submit'
        size = 'sm'
        label = { `${ action === 'create' ? 'Create' : 'Update' } Address` }
        color = 'primary'
    />

    {#if showCancel}
        <Button
            type = 'button'
            size = 'sm'
            label = 'Cancel'
            color = 'neutral'
            on:click = { onCancel }
        />
    {/if}
</div>


<style>

    div[class^='s8-row'] {
        display: grid;
        -moz-column-gap: 10px;
             column-gap: 10px;
    }

        div[class^='s8-row'].s8-row-of-3 {
            grid-template-columns: repeat(3, 1fr);
        }

    div.s8-form-buttons {
        display: flex;
        justify-content: space-between;
    }

    div.s8-contacts {
        margin-bottom: 22px;
    }</style>